function showTrial()
{
  const trialTypes = {
    'INSTRUCTIONS': 0,
    'IMAGES': 1,
    'WORDS': 2,
    'AUDIO': 3,
    'VIDEO': 4,
    'SURVEY': 5,
    'FORM': 6
  }

  window.isActiveResponseWindow = false;
  window.currentScreenIndex = 1;

  if(window.stopBackgroundAudioRow[trialRow]) {
    window.stopBackgroundAudio();
  }

  const timerLabel = window.listTrialTimerLabels[trial];
  if (window.currentTimerLabel != timerLabel) {
    window.cleanTimers();
    window.currentTimerLabel = timerLabel;
    if (window.timers[timerLabel]) {
      showNewTimer(window.timers[window.currentTimerLabel]);
    }
  }

  resetResponseWindow();

  //check if text and/or background colors are defined in the columns
  if (listArrays[allColumns.indexOf('bgColor')][trialRow]!="na"){
    document.body.style.background = listArrays[allColumns.indexOf('bgColor')][trialRow];
    document.documentElement.style.background = listArrays[allColumns.indexOf('bgColor')][trialRow];
  }
  if (listArrays[allColumns.indexOf('textSize')][trialRow]!="na"){
    document.body.style.fontSize = listArrays[allColumns.indexOf('textSize')][trialRow];
    document.documentElement.style.fontSize = listArrays[allColumns.indexOf('textSize')][trialRow];
    document.getElementById("displayScreen").style.fontSize = listArrays[allColumns.indexOf('textSize')][trialRow];
  }
  if (window.columnForTrial('textColor', window.trialRow)!="na"){
    let textColorValue = window.columnForTrial('textColor', window.trialRow)
    if(!textColorValue.includes(';')){
      document.body.style.color = columnForTrial('textColor', window.trialRow);
    }
    document.documentElement.style.color = columnForTrial('textColor', window.trialRow);
  }

  if(listTrialColorOptions[window.trialRow]){
    window.applyColorOptions(listTrialColorOptions[window.trialRow]);
  }

  // show form trial; return since we don't use the additinonal logic for showing stims
  // any following trials of form type will be automatically shown
  // the showFormTrial function will automatically advance the trial rows
  if (listArrays[allColumns.indexOf('type')][trialRow] == 'form') {
    showFormTrial();
    return;
  }

      //show progress bar if needed
      percProgressBar = computeProgressBar();
      if (progressBar) {
        document.getElementById("progressBar").style.width = percProgressBar + "%";
        document.getElementById("progressBar").style.display = 'block';
      } else {
        document.getElementById("progressBar").style.display = 'none';
      }

  //for images compute positioning
  //required here for ITI
  if (listStimType[trialRow] == trialTypes['IMAGES'] || (listStimType[trialRow] == trialTypes['WORDS'] && columnForTrial('stimPos') !== 'na')) {
    verticalShift = 0;
    if ( hasTarget(trialRow) && !isTargetAlone(trialRow)) {
      outsideTopCanvas = Math.min(0, canvasHeight/2 - image1height/2 - spaceTargetImages - imageTargetHeight - borderImage);
      verticalShift = -outsideTopCanvas;
    }

    window.stimuliPositions = computeStimuliPositions();

    var bounds = computeStimuliBounds(window.stimuliPositions);

    if (bounds) {
      window.minTrialAllImagesTop = bounds.minTop;
      window.maxTrialAllImagesTop = bounds.maxTop;
      window.maxTrialAllImagesHeight = bounds.maxHeight;
      window.maxTrialBottom = bounds.maxBottom;
      window.stimRightBound = bounds.maxLeft;
    }
  }
  showFixationITI(trialRow);

  //show ITI text if any
  showTrialTextITI(trialRow);

  var currentITI = computeRandomSelection(columnForTrial('ITI', trialRow));
  console.log('currentITI', columnForTrial('ITI', trialRow), currentITI);
  var currentListStimType = listStimType[trialRow];

  window.initCursor();
  window.initCorrectStim();

  switch (currentListStimType)
  {
    case 0: //instructions
        window.hideTrialText(trialRow);
        window.showInstructions();
        break;
    // unified behaviour for images and words
    case 1: //images
    case 2: //words
      var audioOptions = listBackgroundAudioOptions[trialRow];
      eventTimeOutITI = postpone(function (info) {
        window.hideTrialText(trialRow);
        window.recordITI(info);
        //check play audio
        // var audio = columnForTrial('audio', trialRow);
        
        if (audioOptions && audioOptions.filename != 'na') {
          playAuxiliaryAudio(audioOptions, function () {
            // show background
            showBackgroundWithStim(trialRow);

            if (currentListStimType == 1) {
              showImages();
            } else {
              showWords();
            }
          });
        } else {
          // show background
          showBackgroundWithStim(trialRow);

          if (currentListStimType == 1) {
            showImages();
            // show background
            showBackgroundWithStim(trialRow);
          } else {
            showWords();
          }
        }
      }, currentITI, window.lastTs);
        if(audioOptions && audioOptions.stop) {
          window.stopBackgroundAudio();
        }
        break;
    case 3: //audio/video
    case 4:
        showBackgroundWithStim(trialRow)
        console.log('media play');
        trialInfo.stimOptionsText = listArrays[allColumns.indexOf('stimOptions')][trialRow];
        trialInfo.hasControls = trialInfo.stimOptionsText.indexOf('controls') >= 0;
        trialInfo.hasLoop = trialInfo.stimOptionsText.indexOf('loop') >= 0;
        trialInfo.isMuted = trialInfo.stimOptionsText.indexOf('muted') >= 0;
        trialInfo.hasAutoplay = trialInfo.stimOptionsText.indexOf('noAutoplay') < 0;
        trialInfo.keep = trialInfo.stimOptionsText.indexOf('keep') >= 0;
        eventTimeOutITI = postpone(function(info){
          window.hideTrialText(trialRow);
          window.recordITI(info);
          playSoundsAndMovies();
        }, currentITI, window.lastTs);
        break;
    case 5: //survey
        eventTimeOutITI = postpone(function(info){
          window.recordITI(info);
          showSurvey();
        }, currentITI, window.lastTs);
        timeInMs = performance.now();
        break;
    case 7: //app
        eventTimeOutITI = postpone(function(info){
          window.recordITI(info);
          showHtml();
        }, currentITI, window.lastTs);
        timeInMs = performance.now();
        break;
  }
  if(visualViewport.width <= 400) {
    postpone(function() {
      adjustForMobile();
    }, currentITI+1);
  }
}